import { render, staticRenderFns } from "./RandomText.vue?vue&type=template&id=c228d638&scoped=true&"
import script from "./RandomText.vue?vue&type=script&lang=js&"
export * from "./RandomText.vue?vue&type=script&lang=js&"
import style0 from "./RandomText.vue?vue&type=style&index=0&id=c228d638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c228d638",
  null
  
)

export default component.exports